import React from 'react';

import { AboutUs, Projets, Reseaux, Header, Partenaires, Participation } from './container';
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <AboutUs />
    <Projets />
    <Participation />
    <Partenaires />
    <Reseaux />
  </div>
);

export default App;
